import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useDistrictContext } from 'src/contexts/district.context';
import { getDistrictStatus } from 'src/selectors/district.selector';
import { actionTypes } from 'src/ducks/district.duck';
import { IDistrictForm } from 'src/models/district.model';
import DistrictForm from '../district-form/district-form.component';
import style from '../district-list/district-list.module.scss';

const DistrictAdd: React.FC = () => {
  const { state, actions } = useDistrictContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [company, setCompany] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues = {
    value: undefined,
    relationship: undefined,
  };

  const addStatus = getDistrictStatus(state, actionTypes.DISTRICT_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IDistrictForm = {
        value: data.value,
        relationship: data.relationship,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(Lang.MSG_DISTRICT_ADD_SUCCESS, data.value)
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_DISTRICT}
      content={
        <div className={style.content}>
          <DistrictForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
            company={setCompany}
            companyName={company}
            editIsOpen={false}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default DistrictAdd;
